import cx from 'classnames';
import React from 'react';

import {TestId} from '../../../utils/testIds';
import type {
    NotificationItem,
    NotificationItemId,
} from '../../elements/Notification/Notification';
import {Notification} from '../../elements/Notification/Notification';

import styles from './NotificationsList.module.scss';

export const NotificationsList = <TGroup extends string = string>({
    size = 'medium',
    notifications,
    handleClose,
    className,
}: {
    size?: 'medium' | 'large';
    className?: string;
    notifications: NotificationItem<TGroup>[];
    handleClose: (id: NotificationItemId, group?: TGroup) => void;
}) => {
    return (
        <div
            data-testid={TestId.NotificationsList}
            className={cx(styles.notificationList, className)}
        >
            {notifications.map(
                ({
                    buttons,
                    closeAt,
                    closeTimeout,
                    revision,
                    isClosable,
                    id,
                    group,
                    icon,
                    avatarDisplayName,
                    text,
                    onClick,
                }) => (
                    <Notification<TGroup>
                        key={id}
                        id={id}
                        icon={icon}
                        group={group}
                        isClosable={isClosable}
                        closeAt={closeAt}
                        closeTimeout={closeTimeout}
                        revision={revision}
                        buttons={buttons}
                        size={size}
                        avatarDisplayName={avatarDisplayName}
                        text={text}
                        onClick={onClick}
                        handleClose={handleClose}
                    />
                ),
            )}
        </div>
    );
};

export type NotificationsListProps = React.ComponentProps<
    typeof NotificationsList
>;
